import { createReducer } from '@reduxjs/toolkit';
import {
	API_GET_ALL_BOX_LIVE,
	API_GET_ALL_BOX_LIVE_FAIL,
    API_GET_ALL_BOX_LIVE_SUCCESS,
    API_PUT_BOX_AVAILABLE,
    API_PUT_BOX_AVAILABLE_SUCCESS,
    API_PUT_BOX_AVAILABLE_FAIL,
    API_PUT_BOX_BUSY,
    API_PUT_BOX_BUSY_SUCCESS,
    API_PUT_BOX_BUSY_FAIL,
    API_GET_MY_BOX_STATUS,
    API_GET_MY_BOX_STATUS_FAIL,
    API_GET_MY_BOX_STATUS_SUCCESS
} from 'actions/live';

import { errorHandler, ErrorAction } from 'utils/error';

const initialState = {
	list: [],
	loading: false,
};

const live = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_BOX_LIVE]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_BOX_LIVE_FAIL]: (state, action) => {
		errorHandler('Live Call', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_BOX_LIVE_SUCCESS]: (state, action) => {
        state.loading = false;
		state.list = action.payload.data;
    },
    
    [API_PUT_BOX_AVAILABLE]: (state, action) => {
        state.loading = true;
	},
	[API_PUT_BOX_AVAILABLE_FAIL]: (state, action) => {
		errorHandler('Live Call Available', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_PUT_BOX_AVAILABLE_SUCCESS]: (state, action) => {
        state.loading = false;
        if (action.payload.data.Erreur === 'OK'){
            if (state.list && action.meta.previousAction.payload.request.data.center) {
                
                let centerIndex = state.list.findIndex(
                    (elt) => elt.id === action.meta.previousAction.payload.request.data.center.id
                );
    
                let boxIndex = state.list[centerIndex].boxes.findIndex(
                    (elt) => elt.id === action.meta.previousAction.payload.request.data.id
                );
    
                if (boxIndex !== -1)
                    state.list[centerIndex].boxes[
                        boxIndex
                    ].live= '#6ac906';
            }
        }
        else {
            if (state.list) {
                let centerIndex = state.list.findIndex(
                    (elt) => elt.id === action.meta.previousAction.payload.request.data.center.id
                );
                if (centerIndex !== -1){
                    let boxIndex = state.list[centerIndex].boxes.findIndex(
                        (elt) => elt.id === action.meta.previousAction.payload.request.data.id
                    );
                    if (boxIndex !== -1)
                        state.list[centerIndex].boxes.splice(boxIndex, 1)
                }
            }
        }
        
    },
    
    [API_PUT_BOX_BUSY]: (state, action) => {
		state.loading = true;
	},
	[API_PUT_BOX_BUSY_FAIL]: (state, action) => {
		errorHandler('Live Call Busy', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_PUT_BOX_BUSY_SUCCESS]: (state, action) => {
        state.loading = false;
        if (action.payload.data.Erreur === 'OK'){
            if (state.list) {
                let centerIndex = state.list.findIndex(
                    (elt) => elt.id === action.meta.previousAction.payload.request.data.center.id
                );
                if (centerIndex !== -1){
                    let boxIndex = state.list[centerIndex].boxes.findIndex(
                        (elt) => elt.id === action.meta.previousAction.payload.request.data.id
                    );
                    
                    if (boxIndex !== -1)
                        state.list[centerIndex].boxes[
                            boxIndex
                        ].live= 'red';
                }
                
            }
        }
        else {
            if (state.list) {
                let centerIndex = state.list.findIndex(
                    (elt) => elt.id === action.meta.previousAction.payload.request.data.center.id
                );
                if (centerIndex !== -1){
                    let boxIndex = state.list[centerIndex].boxes.findIndex(
                        (elt) => elt.id === action.meta.previousAction.payload.request.data.id
                    );
                    if (boxIndex !== -1)
                        state.list[centerIndex].boxes.splice(boxIndex, 1)
                }
            }
        }
    },
    [API_GET_MY_BOX_STATUS]: (state, action) => {
		state.loading = true;
	},
	[API_GET_MY_BOX_STATUS_FAIL]: (state, action) => {
		errorHandler('Get My Status Failed', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_MY_BOX_STATUS_SUCCESS]: (state, action) => {
        state.loading = false;
        if (!action.payload.data){
            if (state.list) {
                let centerIndex = state.list.findIndex(
                    (elt) => elt.id === action.meta.previousAction.payload.request.params.center.id
                );
                if (centerIndex !== -1){
                    let boxIndex = state.list[centerIndex].boxes.findIndex(
                        (elt) => elt.id === action.meta.previousAction.payload.request.params.id
                    );
                    if (boxIndex !== -1){
                        state.list[centerIndex].boxes.splice(boxIndex, 1)
                    }
                        
                }
            }
        }else{
            if (!state.list){
                state.list = [{...action.meta.previousAction.payload.request.params.center, boxes:[action.meta.previousAction.payload.request.params]}]
            }
            if (state.list) {
                let centerIndex = state.list.findIndex(
                    (elt) => elt.id === action.meta.previousAction.payload.request.params.center.id
                );
                if (centerIndex !== -1){
                    let boxIndex = state.list[centerIndex].boxes.findIndex(
                        (elt) => elt.id === action.meta.previousAction.payload.request.params.id
                    );
                    
                    if (boxIndex !== -1)
                        state.list[centerIndex].boxes[
                            boxIndex
                        ].live= action.payload.data.live;
                    else
                    state.list[centerIndex].boxes.push({...action.meta.previousAction.payload.request.params, live:action.payload.data.live})
                }else{
                    state.list.push({...action.meta.previousAction.payload.request.params.center, boxes:[{...action.meta.previousAction.payload.request.params, live:action.payload.data.live}]})
                }
                
            }
        }
        
    },
});

export default live;

